import { render, staticRenderFns } from "./PageProgress.vue?vue&type=template&id=7d3452eb&"
var script = {}
import style0 from "./PageProgress.scss?vue&type=style&index=0&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports